export function gauge(ctx) {
    return {
        properties: {
            value_color: '#ffffff',
            value_font:  32,
        },
        styles: {
            main: {
                ...ctx.pretty,
                // radius: LV_RADIUS_CIRCLE in firmware's gauge_main (lv_theme_hasp.c:598) — 999 is
                // this codebase's circular-radius convention, a real match, not a stylistic choice.
                radius: 999,
                // padding/scale_width/line_width/scale_border_width were 10/9/3/0 — schema's
                // defaults.styles.main already carry the correct firmware values (padding:10,
                // scale_width:10, line_width:2, scale_border_width:0, lv_theme_hasp.c:590,593,594,597),
                // so only the colours (which have no schema default) need a theme override here.
                line_color: '#888888',        // firmware gauge_main.line_color = hex3(0x888)
                scale_grad_color: '#888888',  // firmware gauge_main.scale_grad_color = hex3(0x888)
                scale_end_color: ctx.primary, // firmware gauge_main.scale_end_color = theme.color_primary
            },
            indicator: {
                // bg_color/radius/border_width/line_width were redundant with the schema's
                // gauge_needle-matched defaults (lv_theme_hasp.c:610-616) — removed.
                line_color: '#ffffff', // firmware gauge_needle.line_color (dark) = LV_COLOR_WHITE; the schema declares no default for this part's line_color, so the theme must supply it
            },
            major_ticks: {
                // scale_width/line_width were 16/4 — schema's defaults.styles.major_ticks already
                // carry the correct firmware gauge_strong values (scale_width:20, line_width:8,
                // lv_theme_hasp.c:604,606).
                line_color: '#888888',        // firmware gauge_strong.line_color = hex3(0x888)
                scale_grad_color: '#888888',  // firmware gauge_strong.scale_grad_color = hex3(0x888)
                scale_end_color: ctx.primary, // firmware gauge_strong.scale_end_color = theme.color_primary
            },
        },
    };
}
